import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }

import Footer from '@/app/components/Footer.vue'
import HeaderAppDesktop from '@/app/components/header/AppDesktop.vue'
import HeaderAppMobile from '@/app/components/header/AppMobile.vue'
import UpgradePromptModal from '@/app/components/UpgradePromptModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  props: {
    hideMobileMenu: { type: Boolean },
    showUpgradePromptModal: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderAppDesktop),
    _renderSlot(_ctx.$slots, "default"),
    (!__props.hideMobileMenu)
      ? (_openBlock(), _createBlock(HeaderAppMobile, { key: 0 }))
      : (_openBlock(), _createBlock(Footer, { key: 1 })),
    (__props.showUpgradePromptModal)
      ? (_openBlock(), _createBlock(UpgradePromptModal, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})